import { modals } from '@mantine/modals';

import { useShowResponseStatus } from '@/shared';
import { useDeleteWhitelistMutation } from '../store/whitelist-api';
import { handleWhitelistDeleteError } from '../utils/helpers/whitelist-errors';

import type { TWhitelist } from '../store/types';

export const useDeleteWhitelist = () => {
  const [deleteWhitelist, { isLoading, isSuccess, error }] = useDeleteWhitelistMutation();
  const deleteError = handleWhitelistDeleteError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Запись успешно удалена',
    error: deleteError,
  });

  const openDeleteModal = (item: TWhitelist) =>
    modals.openConfirmModal({
      title: `Удаление ID ${item.id}`,
      centered: true,
      children: `Вы точно хотите удалить "${item.note}"?`,
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: async () => await deleteWhitelist({ itemId: item.id }),
    });

  return {
    deleteWhitelist,
    openDeleteModal,
    isLoading,
  };
};
